export default __webpack_public_path__ + "static/bai-en-728x90-01412c002ce353e8e631bb77970dbc3f.png";